import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { log } from "@ledgerhq/logs";
import { hashPublicKey } from "./hashPublicKey";
import { getWalletPublicKey } from "./getWalletPublicKey";
import { getTrustedInput } from "./getTrustedInput";
import { startUntrustedHashTransactionInput } from "./startUntrustedHashTransactionInput";
import { serializeTransaction } from "./serializeTransaction";
import { getTrustedInputBIP143 } from "./getTrustedInputBIP143";
import { compressPublicKey } from "./compressPublicKey";
import { signTransaction } from "./signTransaction";
import { hashOutputFull, provideOutputFullChangePath } from "./finalizeInput";
import { getAppAndVersion } from "./getAppAndVersion";
import { DEFAULT_LOCKTIME, DEFAULT_SEQUENCE, SIGHASH_ALL, OP_DUP, OP_HASH160, HASH_SIZE, OP_EQUALVERIFY, OP_CHECKSIG } from "./constants";
import { shouldUseTrustedInputForSegwit } from "./shouldUseTrustedInputForSegwit";
var defaultsSignTransaction = {
  lockTime: DEFAULT_LOCKTIME,
  sigHashType: SIGHASH_ALL,
  segwit: false,
  additionals: [],
  onDeviceStreaming: function onDeviceStreaming(_e) {},
  onDeviceSignatureGranted: function onDeviceSignatureGranted() {},
  onDeviceSignatureRequested: function onDeviceSignatureRequested() {}
};
/**
 *
 */

export function createTransaction(_x, _x2) {
  return _createTransaction.apply(this, arguments);
}

function _createTransaction() {
  _createTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transport, arg) {
    var _defaultsSignTransact, inputs, associatedKeysets, changePath, outputScriptHex, lockTime, sigHashType, segwit, initialTimestamp, additionals, expiryHeight, useTrustedInputForSegwit, onDeviceStreaming, onDeviceSignatureGranted, onDeviceSignatureRequested, a, notify, isDecred, isXST, startTime, sapling, bech32, useBip143, nullScript, nullPrevout, defaultVersion, trustedInputs, regularOutputs, signatures, publicKeys, firstRun, resuming, targetTransaction, getTrustedInputCall, outputScript, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _input, trustedInput, sequence, outputs, index, _result, _i, r, _i2, _i3, input, script, pseudoTX, pseudoTrustedInputs, signature, _i4, signatureSize, keySize, offset, lockTimeBuffer, result, witness, i, tmpScriptData, decredWitness;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _defaultsSignTransact = _objectSpread({}, defaultsSignTransaction, arg), inputs = _defaultsSignTransact.inputs, associatedKeysets = _defaultsSignTransact.associatedKeysets, changePath = _defaultsSignTransact.changePath, outputScriptHex = _defaultsSignTransact.outputScriptHex, lockTime = _defaultsSignTransact.lockTime, sigHashType = _defaultsSignTransact.sigHashType, segwit = _defaultsSignTransact.segwit, initialTimestamp = _defaultsSignTransact.initialTimestamp, additionals = _defaultsSignTransact.additionals, expiryHeight = _defaultsSignTransact.expiryHeight, useTrustedInputForSegwit = _defaultsSignTransact.useTrustedInputForSegwit, onDeviceStreaming = _defaultsSignTransact.onDeviceStreaming, onDeviceSignatureGranted = _defaultsSignTransact.onDeviceSignatureGranted, onDeviceSignatureRequested = _defaultsSignTransact.onDeviceSignatureRequested;

            if (!(useTrustedInputForSegwit === undefined)) {
              _context.next = 16;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return getAppAndVersion(transport);

          case 5:
            a = _context.sent;
            useTrustedInputForSegwit = shouldUseTrustedInputForSegwit(a);
            _context.next = 16;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

            if (!(_context.t0.statusCode === 0x6d00)) {
              _context.next = 15;
              break;
            }

            useTrustedInputForSegwit = false;
            _context.next = 16;
            break;

          case 15:
            throw _context.t0;

          case 16:
            // loop: 0 or 1 (before and after)
            // i: index of the input being streamed
            // i goes on 0...n, inluding n. in order for the progress value to go to 1
            // we normalize the 2 loops to make a global percentage
            notify = function notify(loop, i) {
              var length = inputs.length;
              if (length < 3) return; // there is not enough significant event to worth notifying (aka just use a spinner)

              var index = length * loop + i;
              var total = 2 * length;
              var progress = index / total;
              onDeviceStreaming({
                progress: progress,
                total: total,
                index: index
              });
            };

            isDecred = additionals.includes("decred");
            isXST = additionals.includes("stealthcoin");
            startTime = Date.now();
            sapling = additionals.includes("sapling");
            bech32 = segwit && additionals.includes("bech32");
            useBip143 = segwit || !!additionals && (additionals.includes("abc") || additionals.includes("gold") || additionals.includes("bip143")) || !!expiryHeight && !isDecred; // Inputs are provided as arrays of [transaction, output_index, optional redeem script, optional sequence]
            // associatedKeysets are provided as arrays of [path]

            nullScript = Buffer.alloc(0);
            nullPrevout = Buffer.alloc(0);
            defaultVersion = Buffer.alloc(4);
            !!expiryHeight && !isDecred ? defaultVersion.writeUInt32LE(sapling ? 0x80000004 : 0x80000003, 0) : isXST ? defaultVersion.writeUInt32LE(2, 0) : defaultVersion.writeUInt32LE(1, 0); // Default version to 2 for XST not to have timestamp

            trustedInputs = [];
            regularOutputs = [];
            signatures = [];
            publicKeys = [];
            firstRun = true;
            resuming = false;
            targetTransaction = {
              inputs: [],
              version: defaultVersion,
              timestamp: Buffer.alloc(0)
            };
            getTrustedInputCall = useBip143 && !useTrustedInputForSegwit ? getTrustedInputBIP143 : getTrustedInput;
            outputScript = Buffer.from(outputScriptHex, "hex");
            notify(0, 0); // first pass on inputs to get trusted inputs

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 40;
            _iterator = inputs[Symbol.iterator]();

          case 42:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 59;
              break;
            }

            _input = _step.value;

            if (resuming) {
              _context.next = 52;
              break;
            }

            _context.next = 47;
            return getTrustedInputCall(transport, _input[1], _input[0], additionals);

          case 47:
            trustedInput = _context.sent;
            log("hw", "got trustedInput=" + trustedInput);
            sequence = Buffer.alloc(4);
            sequence.writeUInt32LE(_input.length >= 4 && typeof _input[3] === "number" ? _input[3] : DEFAULT_SEQUENCE, 0);
            trustedInputs.push({
              trustedInput: true,
              value: Buffer.from(trustedInput, "hex"),
              sequence: sequence
            });

          case 52:
            outputs = _input[0].outputs;
            index = _input[1];

            if (outputs && index <= outputs.length - 1) {
              regularOutputs.push(outputs[index]);
            }

            if (expiryHeight && !isDecred) {
              targetTransaction.nVersionGroupId = Buffer.from(sapling ? [0x85, 0x20, 0x2f, 0x89] : [0x70, 0x82, 0xc4, 0x03]);
              targetTransaction.nExpiryHeight = expiryHeight; // For sapling : valueBalance (8), nShieldedSpend (1), nShieldedOutput (1), nJoinSplit (1)
              // Overwinter : use nJoinSplit (1)

              targetTransaction.extraData = Buffer.from(sapling ? [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00] : [0x00]);
            } else if (isDecred) {
              targetTransaction.nExpiryHeight = expiryHeight;
            }

          case 56:
            _iteratorNormalCompletion = true;
            _context.next = 42;
            break;

          case 59:
            _context.next = 65;
            break;

          case 61:
            _context.prev = 61;
            _context.t1 = _context["catch"](40);
            _didIteratorError = true;
            _iteratorError = _context.t1;

          case 65:
            _context.prev = 65;
            _context.prev = 66;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 68:
            _context.prev = 68;

            if (!_didIteratorError) {
              _context.next = 71;
              break;
            }

            throw _iteratorError;

          case 71:
            return _context.finish(68);

          case 72:
            return _context.finish(65);

          case 73:
            targetTransaction.inputs = inputs.map(function (input) {
              var sequence = Buffer.alloc(4);
              sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : DEFAULT_SEQUENCE, 0);
              return {
                script: nullScript,
                prevout: nullPrevout,
                sequence: sequence
              };
            });

            if (resuming) {
              _context.next = 87;
              break;
            }

            // Collect public keys
            _result = [];
            _i = 0;

          case 77:
            if (!(_i < inputs.length)) {
              _context.next = 86;
              break;
            }

            _context.next = 80;
            return getWalletPublicKey(transport, {
              path: associatedKeysets[_i]
            });

          case 80:
            r = _context.sent;
            notify(0, _i + 1);

            _result.push(r);

          case 83:
            _i++;
            _context.next = 77;
            break;

          case 86:
            for (_i2 = 0; _i2 < _result.length; _i2++) {
              publicKeys.push(compressPublicKey(Buffer.from(_result[_i2].publicKey, "hex")));
            }

          case 87:
            if (initialTimestamp !== undefined) {
              targetTransaction.timestamp = Buffer.alloc(4);
              targetTransaction.timestamp.writeUInt32LE(Math.floor(initialTimestamp + (Date.now() - startTime) / 1000), 0);
            }

            onDeviceSignatureRequested();

            if (!useBip143) {
              _context.next = 97;
              break;
            }

            _context.next = 92;
            return startUntrustedHashTransactionInput(transport, true, targetTransaction, trustedInputs, true, !!expiryHeight, additionals, useTrustedInputForSegwit);

          case 92:
            if (!(!resuming && changePath)) {
              _context.next = 95;
              break;
            }

            _context.next = 95;
            return provideOutputFullChangePath(transport, changePath);

          case 95:
            _context.next = 97;
            return hashOutputFull(transport, outputScript);

          case 97:
            if (!(!!expiryHeight && !isDecred)) {
              _context.next = 100;
              break;
            }

            _context.next = 100;
            return signTransaction(transport, "", lockTime, SIGHASH_ALL, expiryHeight);

          case 100:
            _i3 = 0;

          case 101:
            if (!(_i3 < inputs.length)) {
              _context.next = 126;
              break;
            }

            input = inputs[_i3];
            script = inputs[_i3].length >= 3 && typeof input[2] === "string" ? Buffer.from(input[2], "hex") : !segwit ? regularOutputs[_i3].script : Buffer.concat([Buffer.from([OP_DUP, OP_HASH160, HASH_SIZE]), hashPublicKey(publicKeys[_i3]), Buffer.from([OP_EQUALVERIFY, OP_CHECKSIG])]);
            pseudoTX = Object.assign({}, targetTransaction);
            pseudoTrustedInputs = useBip143 ? [trustedInputs[_i3]] : trustedInputs;

            if (useBip143) {
              pseudoTX.inputs = [_objectSpread({}, pseudoTX.inputs[_i3], {
                script: script
              })];
            } else {
              pseudoTX.inputs[_i3].script = script;
            }

            _context.next = 109;
            return startUntrustedHashTransactionInput(transport, !useBip143 && firstRun, pseudoTX, pseudoTrustedInputs, useBip143, !!expiryHeight && !isDecred, additionals, useTrustedInputForSegwit);

          case 109:
            if (useBip143) {
              _context.next = 115;
              break;
            }

            if (!(!resuming && changePath)) {
              _context.next = 113;
              break;
            }

            _context.next = 113;
            return provideOutputFullChangePath(transport, changePath);

          case 113:
            _context.next = 115;
            return hashOutputFull(transport, outputScript, additionals);

          case 115:
            if (firstRun) {
              onDeviceSignatureGranted();
              notify(1, 0);
            }

            _context.next = 118;
            return signTransaction(transport, associatedKeysets[_i3], lockTime, sigHashType, expiryHeight, additionals);

          case 118:
            signature = _context.sent;
            notify(1, _i3 + 1);
            signatures.push(signature);
            targetTransaction.inputs[_i3].script = nullScript;

            if (firstRun) {
              firstRun = false;
            }

          case 123:
            _i3++;
            _context.next = 101;
            break;

          case 126:
            // Populate the final input scripts
            for (_i4 = 0; _i4 < inputs.length; _i4++) {
              if (segwit) {
                targetTransaction.witness = Buffer.alloc(0);

                if (!bech32) {
                  targetTransaction.inputs[_i4].script = Buffer.concat([Buffer.from("160014", "hex"), hashPublicKey(publicKeys[_i4])]);
                }
              } else {
                signatureSize = Buffer.alloc(1);
                keySize = Buffer.alloc(1);
                signatureSize[0] = signatures[_i4].length;
                keySize[0] = publicKeys[_i4].length;
                targetTransaction.inputs[_i4].script = Buffer.concat([signatureSize, signatures[_i4], keySize, publicKeys[_i4]]);
              }

              offset = useBip143 && !useTrustedInputForSegwit ? 0 : 4;
              targetTransaction.inputs[_i4].prevout = trustedInputs[_i4].value.slice(offset, offset + 0x24);
            }

            lockTimeBuffer = Buffer.alloc(4);
            lockTimeBuffer.writeUInt32LE(lockTime, 0);
            result = Buffer.concat([serializeTransaction(targetTransaction, false, targetTransaction.timestamp, additionals), outputScript]);

            if (segwit && !isDecred) {
              witness = Buffer.alloc(0);

              for (i = 0; i < inputs.length; i++) {
                tmpScriptData = Buffer.concat([Buffer.from("02", "hex"), Buffer.from([signatures[i].length]), signatures[i], Buffer.from([publicKeys[i].length]), publicKeys[i]]);
                witness = Buffer.concat([witness, tmpScriptData]);
              }

              result = Buffer.concat([result, witness]);
            } // FIXME: In ZEC or KMD sapling lockTime is serialized before expiryHeight.
            // expiryHeight is used only in overwinter/sapling so I moved lockTimeBuffer here
            // and it should not break other coins because expiryHeight is false for them.
            // Don't know about Decred though.


            result = Buffer.concat([result, lockTimeBuffer]);

            if (expiryHeight) {
              result = Buffer.concat([result, targetTransaction.nExpiryHeight || Buffer.alloc(0), targetTransaction.extraData || Buffer.alloc(0)]);
            }

            if (isDecred) {
              decredWitness = Buffer.from([targetTransaction.inputs.length]);
              inputs.forEach(function (input, inputIndex) {
                decredWitness = Buffer.concat([decredWitness, Buffer.from([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00]), Buffer.from([0x00, 0x00, 0x00, 0x00]), //Block height
                Buffer.from([0xff, 0xff, 0xff, 0xff]), //Block index
                Buffer.from([targetTransaction.inputs[inputIndex].script.length]), targetTransaction.inputs[inputIndex].script]);
              });
              result = Buffer.concat([result, decredWitness]);
            }

            return _context.abrupt("return", result.toString("hex"));

          case 135:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9], [40, 61, 65, 73], [66,, 68, 72]]);
  }));
  return _createTransaction.apply(this, arguments);
}